/**
 * file : MyPage/TournamentRequest.jsx
 * 설명 : 마이 페이지 > 토너먼트 신청 내역
 */

import Info from "./Info";
import { Fnc } from "common/globals";
import { useState , useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Search } from "components/Common/ApiCall";
import { Paging, Spinner } from "components/Common/Componentization";

export default function TournamentRequest() {
  document.title = "토너먼트 신청내역";
  // 경로 지정
  const navigate = useNavigate();
  // 데이터
  const [datas, setDatas] = useState();
  // 데이터 로딩
  const [dataLoading, setDataLoading] = useState(false);
  // 조회 조건
  const [searchWhere, setSearchWhere] = useState({
	  per_page: 5
  });
  // 조회 조건 할당
  const searchWherePut = (key, val) => { setSearchWhere(prevState => ({ ...prevState, [key]: val}))};
  // 조회
  useEffect(() => {
    Search('/get-tournament-request' , setDatas , setDataLoading , searchWhere);
  }, [searchWhere]);

  return(
    <>
      <Spinner show={dataLoading} />
      <div className="mypage_wrap">
        <div className="location">
			    MY PAGE &nbsp; &gt; &nbsp; 나의 정보 &nbsp; &gt; &nbsp; 토너먼트 신청내역
			  </div>
        <Info />
        <div className="mypage_content box_style1">
          <div className="tit"><h2>토너먼트 신청내역</h2></div>
          <div className="tab_mu">
			    	<div className="tab box_style1">
			    		<ul>
                <li onClick={() => navigate("/myPage/tournamentRequest")} className="active">
                  토너먼트 신청내역
                </li>
                <li onClick={() => navigate("/myPage/Message")}>
                  쪽지함
                </li>
                <li onClick={() => navigate("/myPage/inquery")}>
                  문의하기
                </li>
			    		</ul>
			    	</div>
			    </div>
          <div className="table-container">
  	        <table className="table_style1">
              <thead>
                <tr>
                  <th>NO</th>
                  <th>토너먼트 ID</th>
                  <th>토너먼트명</th>
                  <th>신청일</th>
                  <th>신청결과(상태)</th>
                </tr>
              </thead>
              <tbody>
                {
                  (!Fnc.Empty(datas)) &&
                  datas.data.map((data, index) => (
                    <tr key={index}>
                      <td>{datas.currIndex - index}</td>
                      <td>{data.tournament_idx}</td>
                      <td>{data.tournament_name}</td>
                      <td>{data.requset_at}</td>
                      <td><span className={`${data.state === 'S' ? 'bg1' : data.state === 'C' ? 'bg0' : 'bg2'} smallbox`}>{data.state_name}</span></td>
                    </tr>
                  ))
                }
  	          </tbody>
            </table>
            { Fnc.Empty(datas) && <div className='table-no-data'>신청 내역이 존재하지 않아요</div> }
            <Paging pageData={datas} PageChange={searchWherePut} />
          </div>
        </div>
      </div>
    </>
  )
}